import { render } from "./FigureComp.vue?vue&type=template&id=41a422b5&scoped=true"
import script from "./FigureComp.vue?vue&type=script&lang=js"
export * from "./FigureComp.vue?vue&type=script&lang=js"

import "./FigureComp.vue?vue&type=style&index=0&id=41a422b5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41a422b5"]])

export default __exports__